import { PROFILE_QUERY } from '@/gql/queries/user/user.query.gql';
import { useQuery } from '@apollo/client';

export const useUser = () => {
  const { data, loading, error } = useQuery(PROFILE_QUERY, {
    fetchPolicy: 'cache-first'
  });

  return { user: data?.me, loading, error };
};
